<header
  #header
  class="_core-header"
  [ngClass]="{
    '_core-header--custom-bg': appConfig.settings.is_custom_header,
    '_core-header--second-bg': appConfig.settings.header_color
  }"
>
  <div class="_core-header__left-content">
    <div
      class="_logo"
      [ngClass]="{
        '_logo--is-float-logo': appConfig.settings.float_logo
      }"
    >
      <a
        (click)="sendLogoAnalytics(); eventsService.clearSearchSource(true)"
        [routerLink]="['/']"
      >
        <img
          [src]="
            ToolsHelper.minLogoUrl(
              appConfig.configsUrl,
              appConfig.settings.logo
            )
          "
          alt="logo"
        />
      </a>
    </div>
    <app-search *ngIf="!appConfig.settings.is_white_label"></app-search>
    <ul class="_app-menu" *ngIf="appConfig.settings.header_menu.length">
      <li *ngFor="let item of appConfig.settings.header_menu">
        <a [href]="item.link">{{ item.title }}</a>
      </li>
    </ul>
  </div>
  <div class="_core-header__right-content">
    <app-user-block></app-user-block>
  </div>
  <div
    class="_core-header__error-message"
    *ngIf="showError"
    (click)="hideError()"
  >
    {{ errorText }}
  </div>
</header>

<div
  class="_mobile-header"
  [ngClass]="{
    'is-custom-header-bg': appConfig.settings.is_custom_header,
    'second-color-bg': appConfig.settings.header_color
  }"
>
  <div class="_logo">
    <a
      (click)="sendLogoAnalytics(); eventsService.clearSearchSource(true)"
      [routerLink]="['/main']"
    >
      <img
        alt="logo"
        [src]="
          ToolsHelper.minLogoUrl(
            appConfig.configsUrl,
            appConfig.settings.logo
          ) +
          '?v=' +
          nowDate
        "
      />
    </a>
  </div>
  <ul
    class="_mobile-header__menu _app-menu"
    *ngIf="appConfig.settings.header_menu.length"
  >
    <li *ngFor="let item of appConfig.settings.header_menu">
      <a [href]="item.link">{{ item.title }}</a>
    </li>
  </ul>
  <input
    class="_menu-btn"
    type="checkbox"
    id="menu-btn"
    [formControl]="toggleSMobileMenu"
  />
  <label class="_menu-icon" for="menu-btn"
    ><span class="_menu-icon__navicon"></span
  ></label>
</div>
<div
  class="_mobile-menu"
  *ngIf="mobileMenuIsShow"
  [ngClass]="{
    '_mobile-menu--custom-color': appConfig.settings.is_custom_header
  }"
>
  <app-search *ngIf="!appConfig.settings.is_white_label"></app-search>
  <app-user-block [boxBtnMode]="true"></app-user-block>
</div>
<app-gdrp-popup></app-gdrp-popup>
